import { Dispatch } from 'react';
import api, { ApiError, InternalError, isApiError } from '../api/api';
import { EntrepreneurActionType, EntrepreneurReducerAction } from './EntrepreneurReducer';


type GetProfileAction = { profileId: number, referralId?: string, token?: string, originId?: string, isUnpublished?: boolean, permalinkId?: string };
export const getProfileAction = async (dispatch: Dispatch<EntrepreneurReducerAction>, args: GetProfileAction) => {
  const { profileId, referralId, token, originId, permalinkId } = args;
  try {
    if (token) {
      const profile = await api.getEntrepreneurProfile(token, profileId, permalinkId);
      dispatch({ type: EntrepreneurActionType.GetProfileSuccess, payload: profile });
    } else {
      const anonymousEntProfileResponse = await api.getEntrepreneurProfileAnonymous(profileId, referralId, originId, permalinkId);
      dispatch({ type: EntrepreneurActionType.GetProfileSuccess, payload: anonymousEntProfileResponse });
    }
  } catch (e: unknown) {
    console.error(e);
    let payloadError: ApiError;
    if (isApiError(e)) {
      payloadError = e as ApiError;
    } else {
      payloadError = InternalError;
    }
    dispatch({ type: EntrepreneurActionType.GetProfileFailed, payload: payloadError });
  }
};
